import React from 'react';
import { TARIFF_COMMODITIES } from './constants';
import { CommodityToggle, ToggleRow } from './blocks';

const CommodityToggles = ({ value, onToggle }) => {
    const selected = new Set(value || []);

    return (
        <ToggleRow role="group" aria-label="Commodities">
            {TARIFF_COMMODITIES.map((commodity) => (
                <CommodityToggle
                    key={commodity.value}
                    type="button"
                    aria-pressed={selected.has(commodity.value)}
                    onClick={() => onToggle(commodity.value)}
                >
                    {commodity.label}
                </CommodityToggle>
            ))}
        </ToggleRow>
    );
};

export default CommodityToggles;
